import { mergeAttributes, Node } from '@tiptap/core';
import {
  ReactNodeViewRenderer,
  NodeViewWrapper,
  NodeViewProps,
  NodeViewContent,
} from '@tiptap/react';

import { Button, Flex } from '@chakra-ui/react';

function OptionComponentView(_props: NodeViewProps): React.ReactElement {
  return (
    <NodeViewWrapper>
      <Flex justify="flex-end">
        <Button
          contentEditable={false}
          borderRadius="12px 12px 0px 12px"
          alignSelf="flex-end"
          size="sm"
        >
          <NodeViewContent />
        </Button>
      </Flex>
    </NodeViewWrapper>
  );
}

export const StudentQuizOptionExtension = Node.create({
  name: 'optionComponent',

  group: 'block',

  content: 'inline*',

  draggable: true,

  parseHTML() {
    return [
      {
        tag: 'option-component',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['option-component', mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(OptionComponentView);
  },
});
